import React from "react";
import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";

const OutlinedButton = ({
  className,
  text = "",
  variant = "contained",
  color,
  fontColor,
}) => {
  const theme = useTheme();
  return (
    <div className={className}>
      <Button
        sx={{
          backgroundColor: color || theme.COLORS.GREEN.green,
          color: fontColor || theme.COLORS.BLUE.darkBlueGreen,
          borderRadius: "120px 0 120px 120px",
          fontWeight: "bold",
        }}
        variant={variant}
      >
        {text}
      </Button>
    </div>
  );
};

export default OutlinedButton;
